var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.$style['dropdown-menu-list']},[_vm._l((_vm.list),function(item,index){return [(!item.spacer)?_c('DropdownMenuItem',{key:item.title,attrs:{"item":item},on:{"dropdown-toggle":function($event){return _vm.$emit('dropdown-toggle', $event)}}}):_c('BaseHr',{key:'hr' + index})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }